import { AxiosResponse, isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

export type ContactType = {
  name: string;
  phone: string;
  email: string;
  message: string;
};

export const sendContact = async (
  contact: ContactType
): Promise<AxiosResponse> => {
  try {
    const res = await apiClient.post<AxiosResponse>(Endpoints.Contact, {
      ...contact,
    });
    return res;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
